module.exports = __webpack_public_path__ + "img/user.d303733d.png";